import { Link } from 'react-router';

import { Button, cn } from '@workspace/shadcn';

import { Section } from '../components/section.tsx';
import { GridPattern } from '../components/effects/animated-grid-pattern.tsx';
import { BlurFade } from '../components/effects/blur-fade.tsx';
import { FlipWords } from '../components/effects/flip-words.tsx';

const WORDS = ['AI', 'Innovation', 'Data Science', 'Entrepreneurship', 'Coding'];

export function Hero() {
  return (
    <Section className="xs:px-2 overflow-hidden">
      <div className="pt-36 pb-28">
        <BlurFade delay={0.25} inView>
          <div className="relative z-10 max-w-[96%] text-center sm:text-left">
            <h1 className="xs:text-3xl text-5xl font-bold tracking-tighter">
              Learn. Care.
              <br />
              Change Lives with{' '}
              <FlipWords duration={2000} words={WORDS} />
            </h1>
            <p className="text-muted-foreground xs:text-lg my-4 max-w-[640px] text-xl">
              We offer healthcare professionals dynamic learning experiences
              that blend innovation and technology, empowering them to lead
              change and improve healthcare outcomes.
            </p>
            <div className="xs:flex-col flex flex-row justify-center gap-4 sm:justify-start">
              <Link to="/courses">
                <Button className="h-12 px-8 text-base text-white dark:text-black">
                  Our Courses
                </Button>
              </Link>
              <Link to="/courses" aria-label="Learn more about our programs">
                <Button variant="outline" className="h-12 px-8 text-base">
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
        </BlurFade>

        <GridPattern
          height={48}
          width={48}
          numSquares={30}
          maxOpacity={0.25}
          duration={3}
          className={cn(
            '[mask-image:radial-gradient(486px_circle_at_75%_50%,white,transparent)]',
            '-z-10 -mt-4 max-h-[660px] skew-y-12',
          )}
        />
      </div>
    </Section>
  );
}
